import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  email: {
    id: 'leadgen.email',
    defaultMessage: 'Email address',
  },
  errorAlreadyOnWaitlist: {
    id: 'leadgen.existingLead',
    defaultMessage: 'We love your enthusiasm — don’t worry, you’re already on the list!',
  },
  errorDefault: {
    id: 'leadgen.defaultError',
    defaultMessage: 'Something isn’t working out right now.  Sit tight – we should be up and running shortly.',
  },
  errorExistingAccount: {
    id: 'leadgen.existingAccount',
    defaultMessage: 'Oops! This email is already associated with a ClassPass account. {link}.',
  },
  location: {
    id: 'leadgen.location',
    defaultMessage: 'City name',
  },
  signIn: {
    id: 'leadgen.signin',
    defaultMessage: 'Sign in',
  },
  submit: {
    id: 'leadgen.submit',
    defaultMessage: 'Submit',
  },
  thanks: {
    id: 'leadgen.thanks',
    defaultMessage: 'Thanks! You’re officially on the list.',
  },
});
